import { Form, FormProps } from "@/components/form";
import useMonetizacion from "@/features/monetizacion/hooks/use-monetizacion";
import { TransferenciaItemRequest } from "@/shared/types/transferencia";
import { Stack } from "@mui/material";
import { z } from "zod/v4";

export const openCajaFormSchema = z.object({
    transferenciaInicial: z.object({
        items: z.array(z.object({
            monto: z.object({
                items: z.array(z.object({
                    monedaId: z.string().nonempty("Requerido"),
                    cantidad: z.number({ message: "Requerido" })
                }))
            }),
            transferenciaMetodoId: z.string().nonempty("Este campo es requerido")
        })).transform(v => v.filter(vi => vi.monto).map(vi => vi as TransferenciaItemRequest))
    })
})

export default function OpenCajaForm({
    form,
    ...props
}: FormProps<z.input<typeof openCajaFormSchema>>) {
    const { transferenciaMetodos } = useMonetizacion();

    return <Form form={form} gap={3} {...props}>
        <form.Field name="transferenciaInicial.items" mode="array">
            {field => <Stack gap={3}>
                {field.state.value.map((ti, index) => {
                    const metodo = transferenciaMetodos.find(tm => tm.id === ti.transferenciaMetodoId);
                    if (!metodo) return;
                    return <Form.MontoField
                        key={metodo.id}
                        name={`transferenciaInicial.items[${index}].monto`}
                        label={metodo.nombre}
                    />
                })}
            </Stack>}
        </form.Field>
        <Form.SubmitButton size="small">Abrir Caja</Form.SubmitButton>
    </Form>
}